module.exports = __webpack_public_path__ + "img/disclaimer.e9574fa5.png";